var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.654 31.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification",
    transform: "translate(-53.014 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M184.9,465.044a4.7,4.7,0,0,0,8.6,0Z",
    transform: "translate(-123.864 -436.743)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M199.886,2.972a10.57,10.57,0,0,1,3.609.632V3.465A3.469,3.469,0,0,0,200.029,0h-.287a3.469,3.469,0,0,0-3.465,3.465V3.6A10.59,10.59,0,0,1,199.886,2.972Z",
    transform: "translate(-134.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M76.731,100.513H53.95a.928.928,0,0,1-.915-.712.886.886,0,0,1,.487-1.008,4.834,4.834,0,0,0,1.471-2c1.268-2.678,1.534-6.451,1.534-9.144a8.813,8.813,0,0,1,17.626-.035c0,.012,0,.023,0,.035,0,2.693.266,6.466,1.534,9.144a4.833,4.833,0,0,0,1.471,2,.886.886,0,0,1,.487,1.008A.928.928,0,0,1,76.731,100.513Zm.438-1.714h0Z",
    transform: "translate(0 -74.038)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.4678e548d088f19f0659902bb38ed7d1.svg";
export { ForwardRef as ReactComponent };